import { ClientUDFieldComponent } from "../../safety-observation/ClientUDFieldComponent";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import moment from "moment";
import { memo, useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../../request/Postrequest";
import { BIGrey, BILightGrey } from "../../../assets/helpers";
import {
  DELETE_CLIENT_TIMESHEET_JOB_IMAGES,
  DELETE_CLIENT_TIMESHEETS,
  FETCH_CLIENT_TIMESHEET_JOBS_V2_NEW,
  SAVE_CLIENT_TIMESHEET_JOB_IMAGES,
  SAVE_CLIENT_TIMESHEETS_NEW_CREW,
  SAVE_CLIENT_UD_FIELDS_VALUES,
} from "../../../constant/Apipath";
import PictureViewer from "../../../common/PictureViewer";
import TimesheetSkeletonLoader from "../shared/components/TimesheetSkeletonLoader";

import SaveTemplateModal from "../shared/modals/SaveTemplateModal";
import CrewTemplateForm from "./templates/CrewTemplateForm";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeletConfirmModal from "../shared/modals/DeleteConfirmModal";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";

let CLIENT_COLOR = "#000000";

export function CrewTimesheetForemanEntry({ isOpen, onClose, clientTimesheetId }) {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  CLIENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;
  const USER_ID = loginData?.userInformation?.UserId;

  const [data, setData] = useState({});

  const [imageIndex, setImageIndex] = useState(0);
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);

  const [saveAsTemplateModal, setSaveAsTemplateModal] = useState(false);
  const [deleteImageList, setDeleteImageList] = useState([]);

  const [submitLoader, setSubmitLoader] = useState(false);
  const [loader, setLoader] = useState(true);

  const imgRef = useRef(null);

  const [newTemplate, setNewtemplate] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const { TEXT_ACTION_BE_UNDONE, TEXT_SURE_WANT_TO_DELETE_THIS_TIMESHEET } =
    ClientEnglishFallback?.DeletConfirmModal(multiLanguageData?.DeletConfirmModal || {});

  const {
    TEXT_ACTIVITIES,
    TEXT_HOURS,
    TEXT_QTY,
    TEXT_TIMESHEET_TOTAL,
    TEXT_EMPLOYEE,
    TEXT_MILEAGE_OPTIONAL,
    TEXT_NOTES,
    TEXT_DETAIL_MODAL_KM,
    TEXT_MI,
    PLACEHOLDER_SOMETHING,
    TEXT_SUGGESTION_TIMESHEET,
    BUTTON_DELETE_TIMESHEET,
    BUTTON_SUBMIT
  } = ClientEnglishFallback?.AddTimesheetModal(multiLanguageData?.AddTimesheetModal || {});

  useEffect(() => {
    if (isOpen) {
      fetchClientTimesheetData();
    }
  }, [clientTimesheetId, isOpen]);

  const fetchClientTimesheetData = async () => {
    try {
      setLoader(true);
      const timesheetJobObject = {
        PageNr: 1,
        FullSearch: "",
        UserId: USER_ID,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientTimesheetId: clientTimesheetId
          }
        ]
      };
      const getResponse = await Postrequestcall(
        FETCH_CLIENT_TIMESHEET_JOBS_V2_NEW,
        timesheetJobObject,
        TOKEN
      );
      if (getResponse.status === 200) {
        setData(getResponse?.data?.data?.[0] ?? {});
      }
    } catch (err) {
      console.log("fetchClientTimesheetData-> Error When Fetching Client Timesheet Jobs: ", err);
    } finally {
      setLoader(false);
    }
  };

  const handleAddImage = () => {
    imgRef.current.click();
  };

  const handelImageChange = (event) => {
    let files = Array.from(event.target.files);
    files = files.filter((file) => file.type.startsWith("image/"));
    const newImages = [...data?.pictureList];
    for (let i = 0; i < files.length; i++) {
      newImages.push({
        isNew: true,
        file: files[i]
      });
    }
    setData({ ...data, pictureList: newImages });
    event.target.value = "";
  };

  const handleRemoveImage = useCallback(
    (picture, index) => {
      const deleteList = [...deleteImageList];
      if (picture.id) {
        deleteList.push({ id: picture?.id });
      }
      setDeleteImageList(deleteList);
      let temp = [...data?.pictureList];
      temp.splice(index, 1);
      setData({ ...data, pictureList: temp });
    },
    [data, deleteImageList]
  );

  const onEmployeeValueChangeText = (e, key, index) => {
    let updatedData = { ...data };
    if (key === "mileage") {
      let input = e.target.value;
      input = input.replace(/\D/g, "");
      if (input.length > 3) {
        input = input.slice(0, 3); // maximum 3 digits before adding .
      }
      let formatted = "";
      if (input.length > 2) {
        formatted = `${input.slice(0, 2)}.${input.slice(2, 3)}`; // 2 digits + '.' + 1 digit
      } else {
        formatted = input; // Less than 3 digits, no '.'
      }
      updatedData.timesheetEmployeesList[index] = {
        ...updatedData.timesheetEmployeesList[index],
        [key]: key === "mileage" ? formatted : e.target.value
      };
      setData(updatedData);
    } else {
      updatedData.timesheetEmployeesList[index] = {
        ...updatedData.timesheetEmployeesList[index],
        [key]: e.target.value === 1 ? "km" : "mi"
      };
      setData(updatedData);
    }
  };

  const onJobActivityQtyChange = (e, index) => {
    let updatedData = { ...data };
    updatedData.timesheetActivitiesList[index] = {
      ...updatedData.timesheetActivitiesList[index],
      qty: e.target.value
    };
    setData(updatedData);
  };

  const onActivityUdfieldChange = (actIndex, id, value, type) => {
    let updatedData = { ...data };
    let getActivity = updatedData?.timesheetActivitiesList.map((item, aindex) => {
      if (actIndex === aindex) {
        let udList = item.udFieldsList.map((field) => {
          if ((field.id || field.udFieldId) === id) {
            return {
              ...field,
              value: type === "checkbox" ? (value ? "true" : "false") : value
            };
          }
          return field;
        });
        return {
          ...item,
          udFieldsList: udList
        };
      }
      return item;
    });
    setData({ ...updatedData, timesheetActivitiesList: getActivity });
  };

  const onEmployeeUdfieldChange = (empIndex, id, value, type) => {
    let updatedData = { ...data };
    let getEmployee = updatedData?.timesheetEmployeesList.map((item, eindex) => {
      if (empIndex === eindex) {
        let udList = item.udFieldsList.map((field) => {
          if ((field.id || field.udFieldId) === id) {
            return {
              ...field,
              value: type === "checkbox" ? (value ? "true" : "false") : value
            };
          }
          return field;
        });
        return {
          ...item,
          udFieldsList: udList
        };
      }
      return item;
    });
    setData({ ...updatedData, timesheetEmployeesList: getEmployee });
  };

  const handleEmpHourChange = (text, index) => {
    // Remove everything except digits and colon
    const cleaned = text.replace(/[^\d:]/g, "");
    // If cleared
    if (cleaned === "") {
      let updatedData = { ...data };
      updatedData.timesheetHoursList[index] = {
        ...updatedData.timesheetHoursList[index],
        hours: "",
        isHoursEdit: true
      };
      setData(updatedData);
      return;
    }
    // Remove existing colon to handle reformat
    const digitsOnly = cleaned.replace(":", "").slice(0, 4);
    let formatted = digitsOnly;
    if (digitsOnly.length >= 3) {
      formatted = `${digitsOnly.slice(0, 2)}:${digitsOnly.slice(2)}`;
    } else if (digitsOnly.length >= 1 && digitsOnly.length <= 2) {
      formatted = `${digitsOnly}`;
    }
    let updatedData = { ...data };
    updatedData.timesheetHoursList[index] = {
      ...updatedData.timesheetHoursList[index],
      hours: formatted,
      isHoursEdit: true
    };
    setData(updatedData);
  };

  const handelHoursBlur = (index) => {
    const hourEntry = data.timesheetHoursList.find((item) => item.id === index);
    if (!hourEntry) return;
    let value = hourEntry.hours?.toString().trim() || "";
    let formattedValue = value;
    if (/^\d+$/.test(value)) {
      formattedValue = `${value}:00`;
    } else if (/^\d+:$/.test(value)) {
      formattedValue = `${value}00`;
    } else if (/^(\d+):(\d{1,2})$/.test(value)) {
      const [_, hours, minutes] = value.match(/^(\d+):(\d{1,2})$/);
      const paddedMinutes = minutes.padStart(2, "0");
      formattedValue = `${hours}:${paddedMinutes}`;
    }
    setData((prev) => ({
      ...prev,
      timesheetHoursList: prev.timesheetHoursList.map((item) =>
        item.id === index ? { ...item, hours: formattedValue, isFocused: true } : item
      )
    }));
  };

  const getHoursInDecimal = (timeStr) => {
    if (!timeStr) return 0;
    if (typeof timeStr === "number") return Number(timeStr.toFixed(2));
    const str = String(timeStr);
    return Number(str.replace(":", "."));
  };
  const getudFieldsString = (data, key = "fieldDefaultValue") => {
    if (!data?.length) return "";

    const fieldsObject = data.reduce((acc, item) => {
      acc[item.id] = item?.[key] === "true" ? 1 : 0;
      return acc;
    }, {});

    return JSON.stringify(fieldsObject);
  };

  const handleUDFieldsUpload = async (getResponse) => {
    try {
      const responseData = getResponse?.data?.data || [];
      if (!responseData.length) return;

      const firstObjData = responseData[0]?.objData;
      let clientTimesheetId = firstObjData?.ClientTimesheetId ?? 0;
      let clientTimesheetJobId = firstObjData?.ClientTimesheetJobId ?? 0;

      let udSaveList = [];
      const CLIENT_ID_REF = typeof selectedClientData !== "undefined" ? selectedClientData?.ClientId : (typeof CLIENT_ID !== "undefined" ? CLIENT_ID : 0);
      const CLIENT_EMP_ID_REF = typeof selectedClientData !== "undefined" ? selectedClientData?.ClientEmployeeId : (typeof CLIENT_EMPLOYEE_ID !== "undefined" ? CLIENT_EMPLOYEE_ID : 0);

      if (data?.udFieldsList?.length > 0) {
        data.udFieldsList.forEach((field) => {
          let valStr = field.value !== undefined ? field.value.toString() : "";
          udSaveList.push({
            Id: field.id || 0,
            ClientId: CLIENT_ID_REF,
            ClientEmployeeId: CLIENT_EMP_ID_REF,
            AppId: field.appId || 11,
            AppRecordId: field.appRecordId || clientTimesheetId,
            AssociatedRecordId: field.associatedRecordId || clientTimesheetJobId,
            AppEntityId: field.appEntityId || 1,
            EntityRecordId: field.entityRecordId || data.clientJobId || 0,
            UDFieldId: field.udFieldId || field.id,
            Value: valStr,
            ModifiedBy: USER_ID
          });
        });
      }

      data?.timesheetEmployeesList?.forEach(emp => {
        if (emp?.udFieldsList?.length > 0) {
          emp.udFieldsList.forEach(field => {
            let valStr = field.value !== undefined ? field.value.toString() : "";
            let clientTimesheetJobsEmployeeId = field.associatedRecordId || 0;
            if (!clientTimesheetJobsEmployeeId) {
              let foundEmp = firstObjData?.Employees?.find(e => e.ClientEmployeeId === emp.clientEmployeeId);
              if (!foundEmp) {
                for (let res of responseData) {
                  foundEmp = res?.objData?.Employees?.find(e => e.ClientEmployeeId === emp.clientEmployeeId);
                  if (foundEmp) break;
                }
              }
              if (foundEmp) {
                clientTimesheetJobsEmployeeId = foundEmp.ClientTimesheetJobsEmployeeId;
              }
            }

            udSaveList.push({
              Id: field.id || 0,
              ClientId: CLIENT_ID_REF,
              ClientEmployeeId: CLIENT_EMP_ID_REF,
              AppId: field.appId || 11,
              AppRecordId: field.appRecordId || clientTimesheetId,
              AssociatedRecordId: field.associatedRecordId || clientTimesheetJobsEmployeeId,
              AppEntityId: field.appEntityId || 2,
              EntityRecordId: field.entityRecordId || emp.clientEmployeeId,
              UDFieldId: field.udFieldId || field.id,
              Value: valStr,
              ModifiedBy: USER_ID
            });
          });
        }
      });

      data?.timesheetActivitiesList?.forEach((act, index) => {
        if (act?.udFieldsList?.length > 0) {
          let foundAct = firstObjData?.Activities?.find(a => a.ClientActivityId === act.clientActivityId);
          let clientTimesheetJobActivityId = foundAct?.ClientTimesheetJobActivityId || responseData[index]?.objData?.ClientTimesheetJobActivityId || 0;
          act.udFieldsList.forEach(field => {
            let valStr = field.value !== undefined ? field.value.toString() : "";
            let assocId = clientTimesheetJobActivityId || field.associatedRecordId || 0;

            udSaveList.push({
              Id: field.id || 0,
              ClientId: CLIENT_ID_REF,
              ClientEmployeeId: CLIENT_EMP_ID_REF,
              AppId: field.appId || 11,
              AppRecordId: field.appRecordId || clientTimesheetId,
              AssociatedRecordId: assocId,
              AppEntityId: field.appEntityId || 3,
              EntityRecordId: field.entityRecordId || act.clientActivityId,
              UDFieldId: field.udFieldId || field.id,
              Value: valStr,
              ModifiedBy: USER_ID
            });
          });
        }
      });

      if (udSaveList.length > 0) {
        const udPayload = {
          UserId: USER_ID,
          ReturnRecordId: true,
          ReturnRecordError: true,
          SaveList: udSaveList
        };
        const token = typeof loginData !== "undefined" ? loginData?.accessToken : TOKEN;
        await Postrequestcall(SAVE_CLIENT_UD_FIELDS_VALUES, udPayload, token);
      }
    } catch (error) {
      console.error("handleUDFieldsUpload-> Error saving UD fields:", error);
    }
  };

  const onSaveCrewtimesheet = async () => {
    try {
      setSubmitLoader(true);
      const jobEmployeesList = data?.timesheetEmployeesList?.map((emp) => ({
        clientEmployeeId: emp.clientEmployeeId,
        employeeMileage: emp.mileage ? parseFloat(emp.mileage) : 0,
        employeeMileageUnit: emp.mileageUnit || "km",
        isEmployeeUDField: !!emp?.udFieldsList?.length
      })) || [];

      const activitiesList = data?.timesheetActivitiesList?.map((act) => {
        const activityEmployeesList = data?.timesheetEmployeesList?.map((emp) => {
          const hr = data?.timesheetHoursList?.find(
            (h) => h.clientEmployeeId === emp.clientEmployeeId && h.clientJobActivityId === act.clientActivityId
          );
          let getHours = hr ? getHoursInDecimal(hr.hours) : 0;
          return {
            id: hr?.id || 0,
            clientEmployeeId: emp.clientEmployeeId,
            hours: getHours,
            deleted: false,
            clockInTime: hr?.clockInTime && hr.clockInTime !== "00:00" && hr.clockInTime !== "0:00" ? moment(hr.clockInTime, ["hh:mm a", "h:mm A", "HH:mm:ss"]).format("HH:mm:ss") : "00:00:00",
            clockOutTime: hr?.clockOutTime && hr.clockOutTime !== "00:00" && hr.clockOutTime !== "0:00" ? moment(hr.clockOutTime, ["hh:mm a", "h:mm A", "HH:mm:ss"]).format("HH:mm:ss") : "00:00:00",
            isHoursEdit: hr?.isHoursEdit || false,
            employeeStatusId: 1
          };
        });

        return {
          id: 0,
          clientActivityId: act?.clientActivityId,
          activityQty: act?.qty || 0,
          activityQtyUnit: act?.qtyUnit || "",
          activityNotes: act?.notes || "",
          isActivityUDField: !!act?.udFieldsList?.length,
          deleted: false,
          activityEmployeesList: activityEmployeesList || []
        };
      }) || [];

      const timesheetObj = {
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            id: data?.clientTimesheetId || 0,
            userId: USER_ID,
            clientId: selectedClientData?.ClientId,
            date: data?.date ? moment(data?.date).format("YYYY-MM-DDTHH:mm:ss.SSS") : "",
            statusId: 1,
            typeId: data?.typeId,
            clientJobId: data?.clientJobId,
            jobNotes: data?.notes || "",
            isJobUDField: !!data?.udFieldsList?.length,
            deleted: false,
            employeesList: jobEmployeesList,
            activitiesList: activitiesList
          }
        ]
      };

      const getResponse = await Postrequestcall(
        SAVE_CLIENT_TIMESHEETS_NEW_CREW,
        timesheetObj,
        loginData?.accessToken
      );

      let newPictures = data?.pictureList.filter((pic) => pic?.isNew);
      if (newPictures?.length > 0) {
        await saveTimeSheetImages(newPictures);
      }

      if (deleteImageList?.length > 0) {
        await deleteTimeSheetImages();
      }

      if (getResponse.status === 201) {
        await handleUDFieldsUpload(getResponse);

        if (getResponse?.data?.data?.[0]?.objData?.TemplateExists == false) {
          setSaveAsTemplateModal(true);
        } else {
          onClose();
        }
      }
    } catch (error) {
      console.log("onSaveCrewtimesheet-> Error When Savving Client Timesheet: ", error);
    } finally {
      setSubmitLoader(false);
    }
  };

  const saveTimeSheetImages = async (newPictures) => {
    try {
      const uploadActivityImage = newPictures?.map(async (images, index) => {
        const formData = new FormData();
        formData.append("Id", 0);
        formData.append("ClientTimesheetId", data?.clientTimesheetId);
        formData.append("ClientTimesheetJobId", data?.id);
        formData.append("ClientActivityId", 0);
        formData.append("ClientJobId", data?.clientJobId);
        formData.append("ModifiedBy", USER_ID);
        formData.append("FileName", images?.file);
        await Postrequestcall(
          SAVE_CLIENT_TIMESHEET_JOB_IMAGES,
          formData,
          loginData?.accessToken,
          true
        );
      });
      await Promise.all(uploadActivityImage);
    } catch (e) {
      console.log("saveTimeSheetImages-> Error When Saving Client Timesheet Job Images: ", e);
    }
  };

  const deleteTimeSheetImages = async () => {
    try {
      const deleteId = deleteImageList?.map((pic) => ({ Id: pic?.id }));
      let payload = {
        UserId: USER_ID,
        ReturnRecordId: false,
        ReturnRecordError: true,
        SoftDelete: true,
        DeleteList: deleteId
      };
      await Postrequestcall(DELETE_CLIENT_TIMESHEET_JOB_IMAGES, payload, loginData?.accessToken);
    } catch (error) {
      console.log("deleteTimeSheetImages-> Error When Deleting Client Timesheet Job Images: ", error);
    }
  };

  const onDeleteTimesheetPressed = async () => {
    try {
      const getObject = {
        userId: USER_ID,
        returnRecordId: false,
        returnRecordError: true,
        softDelete: false,
        deleteList: [{ id: Number(data?.clientTimesheetId) }]
      };
      let getResponse = await Postrequestcall(
        DELETE_CLIENT_TIMESHEETS,
        getObject,
        loginData?.accessToken
      );
      if (getResponse.status === 201) {
        onClose();
      }
    } catch (error) {
      console.log("onDeleteTimesheetPressed-> Error When Deleting Client Timesheet: ", error);
    } finally {
    }
  };

  const renderTotalHours = () => {
    let totalMinutes = 0;
    data?.timesheetHoursList?.forEach((item) => {
      const [hh, mm] = item.hours.split(":").map(Number);
      if (!isNaN(hh) && !isNaN(mm)) {
        totalMinutes += hh * 60 + mm;
      }
    });
    const totalHours = Math.floor(totalMinutes / 60);
    const totalRemainingMinutes = totalMinutes % 60;
    // Format with leading zero if needed
    const formattedTotal = `${String(totalHours).padStart(2, "0")}:${String(totalRemainingMinutes).padStart(2, "0")}`;
    return formattedTotal ?? "0.00";
  };

  const saveTemplateHandler = async () => {
    setNewtemplate(true);
  };

  const ImgUrl = (file) => {
    try {
      let url = URL?.createObjectURL(file);
      return url;
    } catch (error) {
      return file;
    }
  };

  const pictureListArray =
    data?.pictureList?.map((item) => {
      return {
        src: item?.fileUrl || ImgUrl(item?.file)
      };
    }) || [];

  const showDeleteTimesheetDialog = () => setShowDeleteModal(true);

  const onJobUdFieldsChange = (id, value, type) => {
    setData((prev) => ({
      ...prev,
      udFieldsList: prev?.udFieldsList?.map((item) => {
        if ((item.id || item.udFieldId) === id) {
          return {
            ...item,
            value: type === "checkbox" ? (value ? "true" : "false") : value
          };
        }
        return item;
      })
    }));
  };

  return (
    <>
      <SaveTemplateModal
        isOpen={saveAsTemplateModal}
        onClose={() => {
          setSaveAsTemplateModal(false);
          onClose();
        }}
        onSave={() => saveTemplateHandler()}
      />

      <DeletConfirmModal
        title={TEXT_ACTION_BE_UNDONE}
        heading={TEXT_SURE_WANT_TO_DELETE_THIS_TIMESHEET}
        onConfirm={() => onDeleteTimesheetPressed()}
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
      />

      {newTemplate && (
        <CrewTemplateForm
          timeSheetData={data}
          from="CrewTimesheet"
          isOpen={newTemplate}
          onClose={() => {
            setNewtemplate(false);
            onClose();
          }}
          templateId={0}
        />
      )}

      <PictureViewer
        isOpen={pictureViewerOpen}
        viewerIndex={imageIndex}
        pictures={pictureListArray}
        onClose={() => setPictureViewerOpen(false)}
      />

      <Modal open={isOpen} onClose={onClose}>
        <Box
          sx={{
            padding: {
              xs: "10px",
              xl: "15px",
              lg: "15px",
              md: "15px",
              sm: "10px"
            },
            backgroundColor: "rgb(235, 235, 235)"
          }}
          className="client-modal-responsive">
          <Stack sx={{ display: "flex", mb: 1, justifyContent: "space-between", alignItems: "center" }} direction={"row"}>
            <IconButton onClick={onClose} style={{ padding: "4px" }}>
              <CloseIcon />
            </IconButton>
          </Stack>
          {loader ? (
            <Box sx={{ width: "100%" }}>
              <TimesheetSkeletonLoader variant="jobList" />
            </Box>
          ) : (
            <>
              <Grid
                sx={{
                  maxHeight: "70vh",
                  overflowY: "auto",
                  scrollbarWidth: "none"
                }}
                container
                spacing={1}>
                <Stack>
                  <Typography variant="h5" sx={{ fontWeight: 400, fontStyle: "normal" }}>
                    {moment(data?.date ?? "").format("MMMM DD, YYYY")}
                  </Typography>
                  <Typography variant="h6" sx={{ color: BIGrey, fontWeight: 400, fontStyle: "normal" }}>
                    {data?.clientJobCode} - {data?.clientJobName}
                  </Typography>
                </Stack>
                <Grid size={12}>
                  <Accordion
                    sx={{ background: "transparent", boxShadow: "none" }}
                    defaultExpanded={true}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        minHeight: "32px !important", // reduce overall height
                        "&.Mui-expanded": {
                          minHeight: "32px !important" // reduce height when expanded
                        },
                        "& .MuiAccordionSummary-content": {
                          margin: "10px 0 !important"
                        },
                        padding: "0px"
                      }}>
                      <Typography variant="h6" sx={{ fontWeight: 500, fontStyle: "normal" }}>
                        {TEXT_ACTIVITIES}
                      </Typography>
                    </AccordionSummary>
                    {data?.timesheetActivitiesList?.map((act, index) => (
                      <AccordionDetails
                        sx={{ borderRadius: "10px", padding: "0px", marginBottom: "10px" }}
                        className="pagelist-content">
                        <Stack style={{ padding: "12px" }}>
                          <Typography variant="h6">
                            {act?.clientJobActivityCode} - {act?.clientJobActivityName}
                          </Typography>
                          <Typography sx={{ color: BIGrey, fontWeight: 400 }}>
                            {TEXT_HOURS}
                          </Typography>
                          {data?.timesheetHoursList?.map(
                            (hrs, index) =>
                              hrs?.clientJobActivityId === act?.clientActivityId && (
                                <Stack sx={{ margin: "5px 0px", justifyContent: "space-between", alignItems: "center" }} direction={"row"}>
                                  <Typography>{hrs?.clientEmployeeName}</Typography>
                                  <TextField
                                    hiddenLabel
                                    size="small"
                                    placeholder="--:--"
                                    value={hrs?.hours === "00:00" ? "" : hrs?.hours?.toString()} // Bind the input value to the state
                                    onChange={(e) => handleEmpHourChange(e.target.value, index)}
                                    onBlur={() => handelHoursBlur(hrs?.id)}
                                    sx={{
                                      "& fieldset": { border: "none" },
                                      "& input": { textAlign: "center" }
                                    }}
                                    style={{
                                      width: "80px",
                                      backgroundColor: "rgba(0, 0, 0, 0.08)",
                                      borderRadius: "5px",
                                      borderColor: "transparent"
                                    }}
                                  />
                                </Stack>
                              )
                          )}
                        </Stack>
                        {(act?.isQuantityApplicable || act?.udFieldsList?.length > 0) && (
                          <Stack
                            sx={{
                              padding: "12px",
                              background: "rgb(250, 250, 250)",
                              borderBottomRightRadius: "10px",
                              borderBottomLeftRadius: "10px"
                            }}>

                            {act?.isQuantityApplicable && (
                              <Stack
                                direction={"row"}
                                sx={{ margin: "5px 0px", alignItems: "center", gap: "10px" }}
                              >
                                <Typography>{TEXT_QTY}</Typography>
                                <TextField
                                  hiddenLabel
                                  size="small"
                                  value={act?.qty}
                                  onChange={(e) => onJobActivityQtyChange(e, index)}
                                  onKeyDown={(e) => {
                                    const allowedKeys = [
                                      "Backspace",
                                      "Tab",
                                      "ArrowLeft",
                                      "ArrowRight",
                                      "Delete"
                                    ];
                                    // Allow digits and control keys
                                    if (!/^[0-9]$/.test(e.key) && !allowedKeys.includes(e.key)) {
                                      e.preventDefault();
                                    }
                                    if (
                                      /^[0-9]$/.test(e.key) &&
                                      e.target.value.length >= 5 &&
                                      window.getSelection().toString().length === 0 && // allow overwriting selected text
                                      e.target.selectionStart === e.target.selectionEnd // no text selected
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  type="number"
                                  name="mileage"
                                  sx={{
                                    width: "70px",
                                    borderColor: "transparent",
                                    backgroundColor: "rgba(0, 0, 0, 0.08)",
                                    borderRadius: "5px",
                                    textAlign: "center",
                                    "& input": {
                                      textAlign: "center",
                                      MozAppearance: "textfield" // For Firefox
                                    },
                                    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                                    {
                                      WebkitAppearance: "none",
                                      margin: 0
                                    },
                                    "& fieldset": {
                                      border: "none"
                                    }
                                  }}
                                />
                                <Typography>{act?.qtyUnit}</Typography>
                              </Stack>
                            )}

                            {act?.udFieldsList?.length > 0 && (
                              <ClientUDFieldComponent mode="edit" udFields={act?.udFieldsList} onChange={(id, val, type) => onActivityUdfieldChange(index, id, val, type)} />
                            )}
                          </Stack>
                        )}
                      </AccordionDetails>
                    ))}
                    <Stack sx={{ padding: "15px 0px", justifyContent: "space-between", alignItems: "center" }} direction={"row"} >
                      <Typography variant="h6">{TEXT_TIMESHEET_TOTAL}</Typography>
                      <Typography variant="h6">{renderTotalHours()}</Typography>
                    </Stack>
                  </Accordion>
                </Grid>
                <Grid size={12}>
                  <Accordion
                    sx={{ background: "transparent", boxShadow: "none" }}
                    defaultExpanded={true}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        minHeight: "32px !important", // reduce overall height
                        "&.Mui-expanded": {
                          minHeight: "32px !important" // reduce height when expanded
                        },
                        "& .MuiAccordionSummary-content": {
                          margin: "10px 0 !important"
                        },
                        padding: "0px"
                      }}>
                      <Typography variant="h6" sx={{ fontWeight: 500, fontStyle: "normal" }}>
                        {TEXT_EMPLOYEE}
                      </Typography>
                    </AccordionSummary>
                    {data?.timesheetEmployeesList?.map((emp, index) => (
                      <AccordionDetails
                        sx={{ borderRadius: "10px", padding: "0px", marginBottom: "10px" }}
                        className="pagelist-content">
                        <Stack style={{ padding: "12px" }}>
                          <Typography variant="h6">{emp?.clientEmployeeName}</Typography>
                          <Stack sx={{ margin: "5px 0px" }}>
                            <Typography>{TEXT_MILEAGE_OPTIONAL}</Typography>
                            <Stack sx={{ gap: '10px' }} direction={"row"} >
                              <TextField
                                hiddenLabel
                                size="small"
                                onChange={(e) => onEmployeeValueChangeText(e, "mileage", index)}
                                value={emp?.mileage}
                                type="number"
                                name="mileage"
                                onKeyDown={(e) => {
                                  const allowedKeys = [
                                    "Backspace",
                                    "Tab",
                                    "ArrowLeft",
                                    "ArrowRight",
                                    "Delete"
                                  ];
                                  // Allow digits and control keys
                                  if (!/^[0-9]$/.test(e.key) && !allowedKeys.includes(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                sx={{
                                  width: "120px",
                                  borderColor: "transparent",
                                  backgroundColor: "rgba(0, 0, 0, 0.08)",
                                  borderRadius: "5px",
                                  // Remove arrows in input
                                  "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                                  {
                                    WebkitAppearance: "none",
                                    margin: 0
                                  },
                                  "& input[type=number]": {
                                    MozAppearance: "textfield" // Firefox
                                  },
                                  "& fieldset": { border: "none" }
                                }}
                              />
                              <Select
                                size="small"
                                style={{
                                  backgroundColor: "rgba(0, 0, 0, 0.08)",
                                  borderColor: "transparent"
                                }}
                                sx={{
                                  "& fieldset": { border: "none" }
                                }}
                                value={emp?.mileageUnit === "km" ? 1 : 2}
                                onChange={(e) =>
                                  onEmployeeValueChangeText(e, "mileageUnit", index)
                                }>
                                <MenuItem value={1}>{TEXT_DETAIL_MODAL_KM}</MenuItem>
                                <MenuItem value={2}>{TEXT_MI}</MenuItem>
                              </Select>
                            </Stack>
                          </Stack>
                          {emp?.udFieldsList?.length > 0 && (
                            <Grid sx={{ mt: 1 }} size={12}>
                              <ClientUDFieldComponent mode="edit" udFields={emp?.udFieldsList} onChange={(id, val, type) => onEmployeeUdfieldChange(index, id, val, type)} />
                            </Grid>
                          )}
                        </Stack>
                      </AccordionDetails>
                    ))}
                  </Accordion>
                </Grid>
                <Grid size={12}>
                  <Accordion
                    sx={{ background: "transparent", boxShadow: "none" }}
                    defaultExpanded={true}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        minHeight: "32px !important", // reduce overall height
                        "&.Mui-expanded": {
                          minHeight: "32px !important" // reduce height when expanded
                        },
                        "& .MuiAccordionSummary-content": {
                          margin: "10px 0 !important"
                        },
                        padding: "0px"
                      }}>
                      <Typography variant="h6" sx={{ fontWeight: 500, fontStyle: "normal" }}>
                        {TEXT_NOTES}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails
                      sx={{ borderRadius: "10px", padding: "0px", marginBottom: "10px" }}
                      className="pagelist-content">
                      <Stack style={{ padding: "12px" }}>
                        <TextField
                          placeholder={PLACEHOLDER_SOMETHING}
                          hiddenLabel
                          multiline
                          rows={2}
                          fullWidth
                          value={data?.notes}
                          sx={{
                            marginTop: 1,
                            backgroundColor: "rgba(0, 0, 0, 0.08)",
                            borderRadius: "5px",
                            "& fieldset": { border: "none" }
                          }}
                          onChange={(e) => {
                            e.preventDefault();
                            let inputValue = e.target.value;
                            inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                            const updatedData = { ...data };
                            updatedData.notes = inputValue;
                            setData(updatedData);
                          }}
                        />
                        <Grid sx={{ gap: 2, marginTop: 2, display: "flex" }} size={12}  >
                          <div
                            onClick={handleAddImage}
                            style={{
                              cursor: "pointer",
                              height: "100px",
                              minWidth: "100px",
                              border: "2px solid #e4e4e4",
                              borderRadius: "10px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center"
                            }}>
                            <AddIcon />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              maxWidth: "100%",
                              height: "100%",
                              scrollbarWidth: "none",
                              overflow: "scroll"
                            }}>
                            {data?.pictureList?.length > 0 && (
                              <ImageMemoComponent
                                setPictureIndex={setImageIndex}
                                setPictureViewerOpen={setPictureViewerOpen}
                                uploadedImageList={data?.pictureList}
                                handleRemoveImage={handleRemoveImage}
                              />
                            )}
                          </div>

                          <input
                            onChange={handelImageChange}
                            type="file"
                            id="file"
                            ref={imgRef}
                            style={{ display: "none" }}
                            multiple
                            accept="image/png, image/jpeg, image/jpg"
                          />
                        </Grid>
                        {data?.udFieldsList?.length > 0 && (
                          <Grid sx={{ m: 1, size: 12 }}>
                            <ClientUDFieldComponent mode="edit" udFields={data?.udFieldsList} onChange={(id, val, type) => onJobUdFieldsChange(id, val, type)} />
                          </Grid>
                        )}
                      </Stack>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Typography sx={{ color: BIGrey, marginTop: "10px", fontSize: "13px", fontWeight: 400 }} variant="h6"  >
                  {TEXT_SUGGESTION_TIMESHEET}
                </Typography>
                <Button
                  style={{ cursor: "pointer" }}
                  sx={{
                    color: CLIENT_COLOR,
                    textAlign: "center",
                    textTransform: "initial",
                    margin: "5px 0px"
                  }}
                  fullWidth
                  onClick={() => showDeleteTimesheetDialog()}>
                  {BUTTON_DELETE_TIMESHEET}
                </Button>
                <Button
                  disabled={submitLoader}
                  fullWidth
                  sx={{
                    backgroundColor: CLIENT_COLOR,
                    color: "white",
                    borderRadius: "10px",
                    textTransform: "none"
                  }}
                  onClick={() => onSaveCrewtimesheet()}>
                  {submitLoader ? <CircularProgress size={24} sx={{ color: "white" }} /> : BUTTON_SUBMIT}
                </Button>
              </Grid>
            </>
          )}
        </Box>
      </Modal>
    </>
  );
}

const ImageList = ({
  uploadedImageList,
  handleRemoveImage,
  setPictureIndex,
  setPictureViewerOpen
}) => {
  const ImgUrl = (file) => {
    try {
      let url = URL.createObjectURL(file);
      return url;
    } catch (error) {
      return file;
    }
  };
  return uploadedImageList?.map((picture, index) => (
    <div style={{ position: "relative", height: "100px" }} key={index}>
      <img
        loading="lazy"
        onClick={() => {
          setPictureViewerOpen(true);
          setPictureIndex(index);
        }}
        src={picture?.fileUrl || ImgUrl(picture?.file)}
        alt={"NO data"}
        style={{
          cursor: "pointer",
          width: "100px",
          height: "100px",
          borderRadius: "10px"
        }}
      />
      <IconButton
        onClick={() => handleRemoveImage(picture, index)}
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          padding: "5px",
          backgroundColor: BILightGrey,
          color: "white"
        }}>
        <CloseIcon style={{ fontSize: "16px" }} />
      </IconButton>
    </div>
  ));
};

const ImageMemoComponent = memo(ImageList);

